const EXTENSIONS = require('constants/mimeTypesExtensions');

const getExtension = (contentType, defaultExt = 'pdf') => EXTENSIONS[contentType] === undefined ? defaultExt : EXTENSIONS[contentType];

module.exports = getExtension;
